import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {ItemActionElement} from "../../atoms/item-actions/item-action-element";
import {ItemActionService} from "../../atoms/item-actions/item-action.service";
import {Store} from "@ngrx/store";
import {OverlayService} from "../../overlay/overlay.service";
import {
  SelfAssessmentIntroComponent
} from "../../user/self-assessment/self-assessment-intro/self-assessment-intro.component";
import {NotificationService} from "../../atoms/notification/notification.service";
import {FavoritesService} from "../../favorites/favorites.service";
import {HeaderService} from "./header.service";
import {RemoveListDialogComponent} from "../../favorites/remove-list-dialog/remove-list-dialog.component";
import {CdColor} from "../../enums/cd-color";
import {GlobalSearchOverlayComponent} from "../../search-filter/global-search-overlay/global-search-overlay.component";
import {UntilDestroy, untilDestroyed} from "@ngneat/until-destroy";
import {Router} from "@angular/router";
import {getAllFavorites} from "../../store/selectors/user.selector";
import {FavoriteEntityType} from "../../enums/favorite-entity-type";
import {DataService} from "../../services/data.service";
import {CodeInputService} from "../../services/code-input.service";
import {SubmenuItem} from "../../interfaces/submenu-item";
import {GamesService} from "../../services/games.service";
import {ProjectAreaService} from "../../services/project-area.service";
import {ProjectArea} from "../../enums/project-area";
import {AuthService} from "../../auth/auth.service";
import {StudentAuthService} from "../../services/student-auth.service";
import {RankingService} from "../../services/ranking.service";
import {TrophyService} from "../../services/trophy.service";
import {AnimationItem} from "lottie-web";
import {environment} from "../../../environments/environment";
import {WatchDataService} from "../../services/watch-data.service";
import {combineLatest, take} from "rxjs";
import {UserRole} from "../../enums/user-role";
import {AccessibilityMenuComponent} from "../accessibility-menu/accessibility-menu.component";

@UntilDestroy()
@Component({
  selector: 'brt-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  @ViewChild('accessibilityButton') accessibilityButton!: ElementRef;
  favoriteItemsNumber = 0;
  bookmarksActionMenu: ItemActionElement[] = [];
  loginActionMenu: ItemActionElement[] = [];
  logoutActionMenu: ItemActionElement[] = [];
  favoriteProfessionsNumber = 0;

  mobileMenuState = false;
  forceCloseDropDown = false;

  gameSubmenuItems: SubmenuItem[] = this.gamesService.getSubmenuItems();

  showGameHeader = false;

  gameLogoArrowAnimation!: AnimationItem;
  allowGameLogoArrowAnimationHover = false;
  isAnyLoggedIn = false;
  loggedInType: "provider" | "school" = "provider";

  currentSubmenuItem = -1;

  constructor(
    private router: Router,
    private itemAction: ItemActionService,
    private favorites: FavoritesService,
    private notificationService: NotificationService,
    private overlay: OverlayService,
    private store: Store,
    private headerService: HeaderService,
    private data: DataService,
    private codeInputService: CodeInputService,
    private gamesService: GamesService,
    private projectAreaService: ProjectAreaService,
    private authService: AuthService,
    private rankingService: RankingService,
    private trophyService: TrophyService,
    private studentAuthService: StudentAuthService,
    private watchDataService: WatchDataService
    ) {

  }

  ngOnInit() {

    this.activateFavoriteItemsNumberListener()
    this.generateBookmarksMenu();
    this.generateLoginMenuItems();
    this.generateLogoutMenuItems();

    this.headerService.onMobileMenuStateChanged().pipe(untilDestroyed(this)).subscribe((newVal) => {
      this.mobileMenuState = newVal;
    })

    this.headerService.onMobileGameMenuStateChanged().pipe(untilDestroyed(this)).subscribe((newVal) => {
      this.mobileMenuState = newVal;
    })

    this.projectAreaService.onAreaUpdated().pipe(untilDestroyed(this)).subscribe((newVal) => {
      if(!environment.schoolClassPreviewMode) {
        this.showGameHeader = newVal === ProjectArea.GAME;
      }
    });

    combineLatest([
      this.studentAuthService.onLoginStateChange(),
      this.authService.isAuthenticated$
    ]).pipe(untilDestroyed(this)).subscribe(([student, teacher]) => {
      this.isAnyLoggedIn = student || teacher;

      this.watchDataService.getUserInfoSubject.pipe(untilDestroyed(this)).subscribe((userInfo) => {
        //console.log(userInfo);
        if(userInfo) {
          this.loggedInType = (userInfo.roles.indexOf(UserRole.ROLE_BOPARTNER) !== -1
            || userInfo.roles.indexOf(UserRole.ROLE_COMPANY) !== -1
            || userInfo.roles.indexOf(UserRole.ROLE_SECONDARY_SCHOOL) !== -1) ? "provider" : "school";
        } else {
          this.loggedInType = "school";
        }
      });

      this.generateLogoutMenuItems();


    })



  }

  activateFavoriteItemsNumberListener() {
    this.store.select(getAllFavorites()).pipe(untilDestroyed(this)).subscribe((favorites) => {
      this.favoriteItemsNumber = favorites.length
      this.favoriteProfessionsNumber = favorites.filter(el => el.type === FavoriteEntityType.PROFESSION).length;
      this.generateBookmarksMenu();
    });
  }

  openSelfAssessmentOverlay() {

    if(window.document.activeElement instanceof HTMLElement) window.document.activeElement.blur();
    this.overlay.addComponent({component: SelfAssessmentIntroComponent, data: {}});
  }

  generateBookmarksMenu() {
    const isEmpty = this.favoriteItemsNumber === 0;
    const singleItem = this.favoriteProfessionsNumber < 2;
    this.bookmarksActionMenu = [
      this.itemAction.generateItem("bookmark-full", "Merkliste anzeigen", true, () => { this.favorites.goToSavedProfessions(); }),
      this.itemAction.generateItem("compare", `${singleItem ? '' : this.favoriteProfessionsNumber} Berufe vergleichen`, !singleItem, () => {
        if(this.favoriteProfessionsNumber > 1) {
          this.router.navigateByUrl("/berufe-vergleichen");
        } else {
          this.notificationService.push("Du musst mind. 2 Berufe auswählen zum vergleichen", CdColor.RIVER, "");
        }
      }),
      this.itemAction.generateItem("code-note", "Merkliste speichern", !isEmpty, () => {
        this.favorites.save();
      }),
      this.itemAction.generateItem("code-enter", "Code eingeben", true, () => {
        this.favorites.openCodeWindow();
      }),
      this.itemAction.generateItem("trash", "Merkliste löschen", !isEmpty, () => {
        this.overlay.openWindowOverlay({title: "Merkliste löschen", componentMain: {component: RemoveListDialogComponent, data: {}}});
      })
    ];
  }

  generateLoginMenuItems(): void {

    if(environment.schoolClassPreviewMode) {
      this.loginActionMenu = [
        this.itemAction.generateItem("code-enter-klasse", "Klassenprofil öffnen", true, () => {
          this.codeInputService.openCodeInputService({
            title: "Gib hier das Klassenkennwort ein um in dein Klassenprofil einzusteigen:",
            pattern: "K***",
            submitButtonLabel: "Los",
            submitCallback: (code) => {
              this.studentAuthService.logIn(code).then((response) => {
                if(response) {
                  this.router.navigateByUrl('/klasse');
                } else {
                  this.notificationService.push("Login fehlgeschlagen", CdColor.RED, "x-thin");
                }
              });
            }
          })
        })
      ]
    } else {
      this.loginActionMenu = [
        this.itemAction.generateItem("code-enter-klasse", "Klassenprofil öffnen", true, async () => {

          const tryLogin = await this.studentAuthService.logInUsingLocalStorage();
          if(tryLogin) {
            this.router.navigateByUrl('/klasse');
          } else {
            this.codeInputService.openCodeInputService({
              title: "Gib hier das Klassenkennwort ein um in dein Klassenprofil einzusteigen:",
              pattern: "K***",
              submitButtonLabel: "Los",
              submitCallback: (code) => {
                this.studentAuthService.logIn(code).then((response) => {
                  if(response) {
                    this.router.navigateByUrl('/klasse');
                  } else {
                    this.notificationService.push("Login fehlgeschlagen", CdColor.RED, "x-thin");
                  }
                });
              }
            })
          }

        }),
        this.itemAction.generateItem("login", "Bei Profil einloggen", true, () => {
          this.login();
        }),
        // this.itemAction.generateItem("login", "Als Anbieter anmelden", true, () => {
        //   window.open("https://www2.berufsreise.at/login", "_blank");
        // }),
        this.itemAction.generateItem("profile", "Kostenlos registrieren", true, () => {
          this.router.navigateByUrl('/registrierung');
        })
      ]
    }


  }

  generateLogoutMenuItems(): void {
    const menuItems: ItemActionElement[] = [];

    if(this.isAnyLoggedIn) {
      if(this.studentAuthService.isLoggedIn()) {
        menuItems.push(this.itemAction.generateItem("prize", "Zur Klasse", true, () => {
          this.router.navigateByUrl('/klasse');
        }))
      }

      if(this.authService.isAuthenticated()) {
        menuItems.push(this.itemAction.generateItem("prize", "Zum Profil", true, () => {
          this.watchDataService.getUserInfoSubject.pipe(take(1)).subscribe((userInfo) => {
            // console.log('userinfo', userInfo);
            if(userInfo && userInfo.roles && userInfo.roles.length) {
              if(userInfo.roles.indexOf(UserRole.ROLE_BOPARTNER) !== -1 ||
                userInfo.roles.indexOf(UserRole.ROLE_COMPANY) !== -1 ||
                userInfo.roles.indexOf(UserRole.ROLE_DIRECTOR) !== -1 ||
                userInfo.roles.indexOf(UserRole.ROLE_SECONDARY_SCHOOL) !== -1) {
                this.router.navigateByUrl('/provider');
                return;
              }
            }

            // default navigation
            this.router.navigateByUrl('/lehrer');
          })
        }))
      }
    }

    menuItems.push(this.itemAction.generateItem("logout", "Abmelden", true, () => {
      this.studentAuthService.logOut();
      this.logout();
    }))

    this.logoutActionMenu = menuItems;

  }

  toggleMobileMenu() {
    this.headerService.setMobileMenuState(!this.mobileMenuState);
  }

  toggleMobileGameMenu() {
    this.headerService.setMobileGameMenuState(!this.mobileMenuState);
  }

  forceCloseMenu() {
    this.forceCloseDropDown = true;
    window.requestAnimationFrame(() => {
      this.forceCloseDropDown = false;
    });
  }

  openGlobalSearch($event: MouseEvent) {
    $event.preventDefault();
    $event.stopPropagation();
    $event.stopImmediatePropagation();
    this.overlay.addComponent({
      component: GlobalSearchOverlayComponent,
      data: {}
    })
  }

  login() {
    this.authService.login();
  }

  logout() {
    this.authService.logout();
  }

  isLoggedIn() {
    return this.authService.isAuthenticated$;
  }

  getUser() {
    this.watchDataService.getUserInfoSubject.subscribe((data) => {
      // console.log(data);
    });
  }

  logoutStudent() {
    this.studentAuthService.logOut();
    this.router.navigateByUrl('/');
  }

  openRankingList() {
    this.rankingService.openRankingOverlay();
  }

  openTrophiesList() {

    this.trophyService.openTrophiesOverlay(this.studentAuthService.getClassData().id);
  }


  onLogoAnimCreated($event: AnimationItem) {
    this.gameLogoArrowAnimation = $event;
    this.gameLogoArrowAnimation.playSegments([0, 60], true);
    //console.log(this.gameLogoArrowAnimation.totalFrames)
    setTimeout(() => {
      this.allowGameLogoArrowAnimationHover = true;
    }, 2000);
  }

  onLogoMouseEnter() {
    if(this.allowGameLogoArrowAnimationHover) {
      const currentFrame = this.gameLogoArrowAnimation.currentFrame;
      // console.log(currentFrame);
      let startFrame = 90;
      if(currentFrame === 59) { // 74 is last frame of in animation; 189 is last frame of hover animation
        this.gameLogoArrowAnimation.playSegments([[60, 212], [0, 60]], true);
      }
    }

  }

  toggleSubmenuItem($event: MouseEvent, number: number) {
    $event.preventDefault();
    if(this.currentSubmenuItem === number) this.currentSubmenuItem = -1;
    else this.currentSubmenuItem = number;
  }

  onDropdownMenuFocusOut($event: FocusEvent, headerComponent: HeaderComponent) {
    const relatedTarget = $event.relatedTarget as HTMLElement | null;
    // relatedTarget is null when focus moves to a non-focusable area or leaves the window
    if(!relatedTarget || ($event.target as HTMLElement).closest(".header-navigation__main-item") !== relatedTarget.closest(".header-navigation__main-item")) {
      this.currentSubmenuItem = -1;
    }
  }

  openAccessibilityMenu($event: MouseEvent) {
    $event.preventDefault();

    this.overlay.openWindowOverlay({
      title: "Barrierefreiheit",
      componentMain: {
        component: AccessibilityMenuComponent,
        data: {}
      },
      previousActiveElement: this.accessibilityButton.nativeElement
    })
  }
}
